import React, { useState, useEffect } from 'react';

const DEFAULT_BLOG_POSTS = [
  {
    id: 1,
    slug: 'mengenal-xharelypos-solusi-kasir-modern',
    category: 'Produk',
    title: 'Mengenal xharelyPOS: Solusi Kasir Modern untuk Bisnis Anda',
    excerpt:
      'xharelyPOS hadir sebagai sistem Point of Sale berbasis cloud yang memudahkan pengelolaan penjualan, inventaris, dan laporan keuangan — semua dalam satu platform yang intuitif.',
    date: '20 Agustus 2026',
    author: 'Tim Xharely',
    readTime: '5 menit baca',
    content: `
## Apa itu xharelyPOS?

xharelyPOS adalah sistem kasir (Point of Sale) modern berbasis cloud yang dirancang khusus untuk kebutuhan bisnis Indonesia — mulai dari UMKM, kafe, restoran, toko retail, hingga bisnis multi-outlet.

Berbeda dengan sistem kasir konvensional yang terbatas pada satu perangkat, xharelyPOS beroperasi di cloud sehingga data Anda dapat diakses kapan saja dan di mana saja.

## Fitur Unggulan

### 1. Manajemen Inventaris Real-Time
Pantau stok barang secara langsung. Setiap transaksi penjualan otomatis memperbarui jumlah stok, dan sistem akan mengingatkan Anda ketika stok menipis.

### 2. Integrasi Pembayaran Lengkap
xharelyPOS mendukung berbagai metode pembayaran:
- **Tunai** — pencatatan otomatis kembalian
- **QRIS** — scan dan bayar dalam hitungan detik
- **Transfer Bank (Virtual Account)** — konfirmasi otomatis
- **E-Wallet** — integrasi dengan dompet digital populer

### 3. Laporan Keuangan Mendalam
Dapatkan insight bisnis Anda melalui laporan penjualan harian, mingguan, bulanan, serta analitik produk terlaris dan performa kasir.

### 4. Multi-Outlet Support
Kelola banyak cabang dari satu dashboard terpusat. Bandingkan performa antar outlet dan atur hak akses masing-masing staf.

### 5. Struk Digital
Kurangi penggunaan kertas dengan struk digital yang dikirim via WhatsApp atau email langsung ke pelanggan.

## Siapa yang Cocok Menggunakan xharelyPOS?

xharelyPOS dirancang untuk:
- **Retail & Toko Kelontong** — manajemen ribuan SKU produk
- **Kafe & Restoran** — manajemen meja dan pesanan
- **UMKM** — solusi terjangkau dengan fitur enterprise
- **Bisnis Multi-Outlet** — kontrol terpusat untuk semua cabang

## Mulai Sekarang

xharelyPOS sudah siap digunakan. Daftar gratis dan rasakan kemudahan mengelola bisnis Anda secara digital.
    `,
    coverColor: 'from-yellow-400 to-yellow-500',
    cover_color: 'from-yellow-400 to-yellow-500',
    icon: (
      <svg className="w-12 h-12 text-black" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M9 7h6m0 10v-3m-3 3h.01M9 17h.01M9 14h.01M12 14h.01M15 11h.01M12 11h.01M9 11h.01M7 21h10a2 2 0 002-2V5a2 2 0 00-2-2H7a2 2 0 00-2 2v14a2 2 0 002 2z" />
      </svg>
    ),
  },
  {
    id: 2,
    slug: 'mengapa-bisnis-butuh-sistem-pos-cloud',
    category: 'Tech',
    title: 'Mengapa Bisnis Modern Membutuhkan Sistem POS Berbasis Cloud?',
    excerpt:
      'Era digital menuntut bisnis bergerak lebih cepat dan efisien. Sistem POS berbasis cloud bukan lagi kemewahan — ini adalah kebutuhan untuk bertahan dan tumbuh di pasar yang kompetitif.',
    date: '15 Agustus 2026',
    author: 'Tim Xharely',
    readTime: '7 menit baca',
    content: `
## Transformasi dari Kasir Konvensional ke Cloud POS

Dulu, sistem kasir berarti satu mesin kasir fisik, struk kertas panjang, dan laporan yang harus direkap manual setiap malam. Kini, semua itu berubah drastis.

Sistem POS berbasis cloud mengubah cara bisnis beroperasi dengan menghadirkan data real-time, aksesibilitas penuh, dan skalabilitas yang tidak terbatas.

## 5 Alasan Bisnis Anda Perlu Cloud POS

### 1. Akses Data Kapan Saja, Di Mana Saja
Dengan cloud POS, pemilik bisnis dapat memantau penjualan, stok, dan laporan keuangan langsung dari smartphone — bahkan saat sedang di luar kota. Tidak perlu lagi menunggu laporan harian dari kasir.

### 2. Tidak Takut Kehilangan Data
Data bisnis tersimpan aman di server cloud dengan backup otomatis. Jika perangkat kasir rusak atau dicuri, data Anda tetap aman dan bisa langsung diakses dari perangkat lain.

### 3. Update Otomatis Tanpa Biaya Tambahan
Software cloud selalu diperbarui secara otomatis. Fitur baru, perbaikan bug, dan peningkatan keamanan diterapkan tanpa Anda perlu melakukan apa pun.

### 4. Skalabilitas Tanpa Batas
Membuka cabang baru? Tambah kasir baru? Dengan cloud POS, ekspansi bisnis tidak memerlukan investasi hardware besar. Cukup tambahkan akun pengguna baru dan mulai beroperasi.

### 5. Integrasi Ekosistem Digital
Cloud POS mudah diintegrasikan dengan sistem lain: akuntansi, e-commerce, loyalty program, dan berbagai payment gateway. Bisnis Anda menjadi satu ekosistem digital yang terhubung.

## Perbandingan: POS Konvensional vs Cloud POS

| Aspek | POS Konvensional | Cloud POS |
|-------|-----------------|-----------|
| Akses data | Lokal saja | Di mana saja |
| Backup data | Manual | Otomatis |
| Update software | Berbayar & manual | Otomatis & gratis |
| Biaya awal | Tinggi (hardware) | Rendah (SaaS) |
| Skalabilitas | Terbatas | Unlimited |

## Kesimpulan

Investasi pada sistem POS berbasis cloud adalah investasi pada efisiensi dan pertumbuhan bisnis jangka panjang. Dengan biaya operasional yang lebih rendah dan kemampuan yang jauh lebih besar, cloud POS adalah pilihan cerdas untuk bisnis modern Indonesia.
    `,
    coverColor: 'from-gray-800 to-gray-900',
    cover_color: 'from-gray-800 to-gray-900',
    icon: (
      <svg className="w-12 h-12 text-yellow-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M3 15a4 4 0 004 4h9a5 5 0 10-.1-9.999 5.002 5.002 0 10-9.78 2.096A4.001 4.001 0 003 15z" />
      </svg>
    ),
  },
  {
    id: 3,
    slug: 'transformasi-digital-umkm',
    category: 'Bisnis',
    title: 'Transformasi Digital UMKM: Dari Manual ke Digital dalam 30 Hari',
    excerpt:
      'Banyak pelaku UMKM masih ragu untuk beralih ke sistem digital. Padahal, transformasi tidak harus rumit atau mahal. Ikuti panduan praktis 30 hari ini untuk mulai digitalisasi bisnis Anda.',
    date: '8 Agustus 2026',
    author: 'Tim Xharely',
    readTime: '8 menit baca',
    content: `
## Kenapa UMKM Harus Go Digital?

Data menunjukkan bahwa UMKM yang mengadopsi teknologi digital memiliki pertumbuhan pendapatan rata-rata 2x lebih cepat dibandingkan yang masih manual. Namun, banyak pelaku UMKM masih ragu — entah karena biaya, kompleksitas, atau tidak tahu harus mulai dari mana.

Artikel ini adalah panduan praktis 30 hari untuk memulai transformasi digital bisnis Anda.

## Minggu 1: Audit & Identifikasi

### Hari 1-3: Pemetaan Proses Bisnis
Tuliskan setiap proses bisnis yang masih manual:
- Pencatatan penjualan
- Pengelolaan stok
- Pencatatan keuangan
- Komunikasi dengan pelanggan

### Hari 4-7: Identifikasi Prioritas
Tentukan mana yang paling menghambat operasional. Biasanya: **pencatatan penjualan dan stok** menjadi prioritas utama.

## Minggu 2: Pilih Solusi yang Tepat

### Kriteria Memilih Software Bisnis
- Mudah digunakan (tidak perlu training panjang)
- Harga terjangkau (model berlangganan bulanan)
- Support lokal (tim yang mengerti kebutuhan bisnis Indonesia)
- Bisa diakses dari HP

### Rekomendasi untuk POS
Untuk manajemen penjualan dan inventaris, sistem POS cloud seperti **xharelyPOS** adalah pilihan yang tepat — dirancang khusus untuk UMKM Indonesia dengan antarmuka yang intuitif.

## Minggu 3: Implementasi & Migrasi Data

### Tips Migrasi yang Lancar
1. **Jangan hapus sistem lama dulu** — jalankan paralel selama 1-2 minggu
2. **Mulai dengan data produk** — masukkan daftar produk dan stok awal
3. **Training staf** — pastikan kasir nyaman menggunakan sistem baru
4. **Coba dengan transaksi kecil dulu** — validasi alur kerja sebelum full deployment

## Minggu 4: Evaluasi & Optimasi

### Metrik yang Perlu Dipantau
- Waktu proses transaksi (harus lebih cepat)
- Akurasi stok (harus lebih presisi)
- Waktu pembuatan laporan (harus jauh lebih cepat)
- Kepuasan staf (lebih mudah bekerja)

## Investasi vs Manfaat

Biaya langganan software bisnis biasanya jauh lebih kecil dibandingkan:
- Waktu yang dihemat dari pencatatan manual
- Kesalahan hitung yang bisa dicegah
- Keputusan bisnis yang lebih baik berkat data real-time

## Langkah Berikutnya

Mulai hari ini. Daftar ke **xharelyPOS** dan coba gratis. Tim kami siap membantu proses onboarding Anda agar transformasi digital berjalan lancar.
    `,
    coverColor: 'from-green-400 to-emerald-500',
    cover_color: 'from-green-400 to-emerald-500',
    icon: (
      <svg className="w-12 h-12 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M13 7h8m0 0v8m0-8l-8 8-4-4-6 6" />
      </svg>
    ),
  },
];

const categories = ['Semua', 'Produk', 'Tech', 'Bisnis'];

function MarkdownContent({ content }) {
  if (!content) return null;
  const normalizedContent = String(content)
    .replace(/\\r\\n/g, '\n')
    .replace(/\\n/g, '\n')
    .replace(/\r\n/g, '\n')
    .replace(/\r/g, '\n');
  const lines = normalizedContent.trim().split('\n');
  const elements = [];
  let i = 0;
  let tableBuffer = [];
  let inTable = false;

  while (i < lines.length) {
    const line = lines[i];

    // Heading 2
    if (line.startsWith('## ')) {
      if (inTable) {
        elements.push(<TableRenderer key={`table-${i}`} rows={tableBuffer} />);
        tableBuffer = [];
        inTable = false;
      }
      elements.push(
        <h2 key={i} className="text-2xl font-bold text-black mt-10 mb-4">
          {line.replace('## ', '')}
        </h2>
      );
    }
    // Heading 3
    else if (line.startsWith('### ')) {
      if (inTable) {
        elements.push(<TableRenderer key={`table-${i}`} rows={tableBuffer} />);
        tableBuffer = [];
        inTable = false;
      }
      elements.push(
        <h3 key={i} className="text-xl font-semibold text-black mt-8 mb-3">
          {line.replace('### ', '')}
        </h3>
      );
    }
    // Table row
    else if (line.startsWith('|')) {
      inTable = true;
      tableBuffer.push(line);
    }
    // List item
    else if (line.startsWith('- ')) {
      if (inTable) {
        elements.push(<TableRenderer key={`table-${i}`} rows={tableBuffer} />);
        tableBuffer = [];
        inTable = false;
      }
      const listItems = [];
      while (i < lines.length && lines[i].startsWith('- ')) {
        listItems.push(lines[i].replace('- ', ''));
        i++;
      }
      elements.push(
        <ul key={i} className="space-y-2 my-4 pl-0">
          {listItems.map((item, idx) => (
            <li key={idx} className="flex items-start gap-3 text-gray-700">
              <span className="mt-2 w-2 h-2 bg-yellow-400 rounded-full flex-shrink-0" />
              <span dangerouslySetInnerHTML={{ __html: item.replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>') }} />
            </li>
          ))}
        </ul>
      );
      continue;
    }
    // Numbered list
    else if (/^\d+\. /.test(line)) {
      if (inTable) {
        elements.push(<TableRenderer key={`table-${i}`} rows={tableBuffer} />);
        tableBuffer = [];
        inTable = false;
      }
      const numItems = [];
      while (i < lines.length && /^\d+\. /.test(lines[i])) {
        numItems.push(lines[i].replace(/^\d+\. /, ''));
        i++;
      }
      elements.push(
        <ol key={i} className="space-y-2 my-4 pl-0 list-none">
          {numItems.map((item, idx) => (
            <li key={idx} className="flex items-start gap-3 text-gray-700">
              <span className="flex-shrink-0 w-6 h-6 bg-black text-white rounded-full flex items-center justify-center text-xs font-bold">
                {idx + 1}
              </span>
              <span
                className="mt-0.5"
                dangerouslySetInnerHTML={{ __html: item.replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>') }}
              />
            </li>
          ))}
        </ol>
      );
      continue;
    }
    // Empty line
    else if (line.trim() === '') {
      if (inTable) {
        elements.push(<TableRenderer key={`table-${i}`} rows={tableBuffer} />);
        tableBuffer = [];
        inTable = false;
      }
    }
    // Paragraph
    else {
      if (inTable) {
        elements.push(<TableRenderer key={`table-${i}`} rows={tableBuffer} />);
        tableBuffer = [];
        inTable = false;
      }
      elements.push(
        <p
          key={i}
          className="text-gray-700 leading-relaxed my-3"
          dangerouslySetInnerHTML={{
            __html: line
              .replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>')
              .replace(/\*(.*?)\*/g, '<em>$1</em>'),
          }}
        />
      );
    }
    i++;
  }

  if (inTable && tableBuffer.length) {
    elements.push(<TableRenderer key="table-final" rows={tableBuffer} />);
  }

  return <div>{elements}</div>;
}

function TableRenderer({ rows }) {
  const dataRows = rows.filter((r) => !r.match(/^\|[-| ]+\|$/));
  if (dataRows.length < 2) return null;
  const headers = dataRows[0]
    .split('|')
    .filter((c) => c.trim() !== '')
    .map((c) => c.trim());
  const body = dataRows.slice(1).map((row) =>
    row
      .split('|')
      .filter((c) => c.trim() !== '')
      .map((c) => c.trim())
  );
  return (
    <div className="overflow-x-auto my-6 rounded-xl border border-gray-200">
      <table className="w-full text-sm">
        <thead>
          <tr className="bg-black text-white">
            {headers.map((h, i) => (
              <th key={i} className="px-4 py-3 text-left font-semibold">
                {h}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {body.map((row, ri) => (
            <tr key={ri} className={ri % 2 === 0 ? 'bg-white' : 'bg-gray-50'}>
              {row.map((cell, ci) => (
                <td key={ci} className="px-4 py-3 text-gray-700 border-t border-gray-100">
                  {cell}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

function getDefaultIcon(category) {
  if (category === 'Tech') {
    return (
      <svg className="w-12 h-12 text-yellow-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M3 15a4 4 0 004 4h9a5 5 0 10-.1-9.999 5.002 5.002 0 10-9.78 2.096A4.001 4.001 0 003 15z" />
      </svg>
    );
  }
  if (category === 'Bisnis') {
    return (
      <svg className="w-12 h-12 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M13 7h8m0 0v8m0-8l-8 8-4-4-6 6" />
      </svg>
    );
  }
  return (
    <svg className="w-12 h-12 text-black" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M9 7h6m0 10v-3m-3 3h.01M9 17h.01M9 14h.01M12 14h.01M15 11h.01M12 11h.01M9 11h.01M7 21h10a2 2 0 002-2V5a2 2 0 00-2-2H7a2 2 0 00-2 2v14a2 2 0 002 2z" />
    </svg>
  );
}

function BlogCard({ post, onRead }) {
  const coverColor = post.coverColor || post.cover_color || 'from-yellow-400 to-yellow-500';
  const icon = post.icon || getDefaultIcon(post.category);

  return (
    <article
      className="bg-white rounded-2xl overflow-hidden border border-gray-100 shadow-sm hover:shadow-xl hover:-translate-y-1 transition-all duration-300 cursor-pointer group"
      onClick={() => onRead(post)}
    >
      {/* Cover */}
      <div className={`bg-gradient-to-br ${coverColor} h-48 flex items-center justify-center relative`}>
        <div className="opacity-80">{icon}</div>
        <span className="absolute top-4 left-4 bg-white/90 text-black text-xs font-bold px-3 py-1 rounded-full">
          {post.category || 'Umum'}
        </span>
      </div>
      {/* Body */}
      <div className="p-6">
        <div className="flex items-center gap-3 text-xs text-gray-400 mb-3">
          <span>{post.date || 'Terbaru'}</span>
          {post.readTime && (
            <>
              <span>·</span>
              <span>{post.readTime}</span>
            </>
          )}
        </div>
        <h3 className="text-lg font-bold text-black mb-3 leading-snug group-hover:text-yellow-600 transition-colors line-clamp-2">
          {post.title}
        </h3>
        <p className="text-gray-600 text-sm leading-relaxed line-clamp-3 mb-4">{post.excerpt}</p>
        <div className="flex items-center justify-between">
          <span className="text-xs text-gray-500 font-medium">{post.author || 'Tim Xharely'}</span>
          <span className="text-xs font-semibold text-black flex items-center gap-1 group-hover:gap-2 transition-all">
            Baca
            <svg className="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
            </svg>
          </span>
        </div>
      </div>
    </article>
  );
}

function isDarkCover(coverColor) {
  if (!coverColor) return false;
  const darkKeywords = [
    'gray-800', 'gray-900', 'slate-800', 'slate-900', 'zinc-800', 'zinc-900',
    'neutral-800', 'neutral-900', 'black', 'indigo-500', 'indigo-600',
    'purple-600', 'purple-700', 'blue-800', 'blue-900', 'rose-600'
  ];
  return darkKeywords.some((keyword) => coverColor.includes(keyword));
}

function BlogDetail({ post, onBack }) {
  const [content, setContent] = React.useState(post.content || '');
  const [loadingContent, setLoadingContent] = React.useState(!post.content);
  const coverColor = post.coverColor || post.cover_color || 'from-yellow-400 to-yellow-500';
  const isDark = isDarkCover(coverColor);

  React.useEffect(() => {
    if (!post.content && post.slug) {
      const apiBase = process.env.REACT_APP_API_URL || '';
      fetch(`${apiBase}/api/blog/posts/${post.slug}/content`)
        .then((res) => res.json())
        .then((data) => {
          if (data.post && data.post.content) {
            setContent(data.post.content);
          }
        })
        .catch((err) => {
          console.warn('Gagal memuat konten artikel lengkap:', err);
        })
        .finally(() => {
          setLoadingContent(false);
        });
    }
  }, [post]);

  return (
    <div className="min-h-screen bg-white">
      {/* Article Header */}
      <div className={`bg-gradient-to-br ${coverColor} pt-32 pb-16 transition-colors duration-300`}>
        <div className="container mx-auto px-6 max-w-3xl">
          <button
            onClick={onBack}
            className={`flex items-center gap-2 transition mb-8 font-medium ${
              isDark ? 'text-white/80 hover:text-white' : 'text-black/70 hover:text-black'
            }`}
          >
            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
            </svg>
            Kembali ke Blog
          </button>
          <span
            className={`text-xs font-bold px-3 py-1.5 rounded-full mb-4 inline-block ${
              isDark
                ? 'bg-yellow-400 text-black shadow-sm'
                : 'bg-black text-white'
            }`}
          >
            {post.category || 'Umum'}
          </span>
          <h1
            className={`text-3xl sm:text-4xl md:text-5xl font-bold leading-tight mt-3 mb-6 ${
              isDark ? 'text-white' : 'text-black'
            }`}
          >
            {post.title}
          </h1>
          <div
            className={`flex items-center gap-4 text-sm ${
              isDark ? 'text-white/80' : 'text-black/70'
            }`}
          >
            <div className="flex items-center gap-2">
              <div
                className={`w-8 h-8 rounded-full flex items-center justify-center ${
                  isDark ? 'bg-white text-black' : 'bg-black'
                }`}
              >
                <span className="text-yellow-400 text-xs font-bold">X</span>
              </div>
              <span className={`font-medium ${isDark ? 'text-white' : 'text-gray-900'}`}>
                {post.author || 'Tim Xharely'}
              </span>
            </div>
            <span>·</span>
            <span>{post.date || 'Terbaru'}</span>
            {post.readTime && (
              <>
                <span>·</span>
                <span>{post.readTime}</span>
              </>
            )}
          </div>
        </div>
      </div>

      {/* Article Body */}
      <div className="container mx-auto px-6 max-w-3xl py-12">
        <p className="text-xl text-gray-600 leading-relaxed mb-10 pb-10 border-b border-gray-100 font-light">
          {post.excerpt}
        </p>

        {loadingContent ? (
          <div className="py-12 text-center text-gray-400 font-medium">
            Memuat isi artikel...
          </div>
        ) : (
          <MarkdownContent content={content || 'Konten artikel belum tersedia.'} />
        )}

        {/* CTA */}
        <div className="mt-14 bg-gradient-to-r from-yellow-400 to-yellow-500 rounded-2xl p-8 text-center">
          <h3 className="text-2xl font-bold text-black mb-3">Siap Mulai Transformasi Digital?</h3>
          <p className="text-black/70 mb-6">
            Coba xharelyPOS gratis dan rasakan perbedaannya.
          </p>
          <a
            href={process.env.REACT_APP_POS_URL || 'https://pos.xharely.com'}
            target="_blank"
            rel="noopener noreferrer"
            className="bg-black text-white px-8 py-3 rounded-full font-semibold hover:bg-gray-800 transition inline-block"
          >
            Coba xharelyPOS
          </a>
        </div>
      </div>
    </div>
  );
}

function Blog({ onBack }) {
  const [posts, setPosts] = useState(DEFAULT_BLOG_POSTS);
  const [activeCategory, setActiveCategory] = useState('Semua');
  const [selectedPost, setSelectedPost] = useState(null);

  useEffect(() => {
    const apiBase = process.env.REACT_APP_API_URL || '';
    fetch(`${apiBase}/api/blog/posts`)
      .then((res) => res.json())
      .then((data) => {
        if (data.posts && data.posts.length > 0) {
          setPosts(data.posts);
        }
      })
      .catch((err) => {
        console.warn('Menggunakan data artikel lokal fallback:', err);
      });
  }, []);

  const filtered =
    activeCategory === 'Semua'
      ? posts
      : posts.filter((p) => p.category === activeCategory);

  if (selectedPost) {
    return (
      <>
        {/* Fixed Navbar in Detail View */}
        <header className="fixed top-0 w-full bg-white/90 backdrop-blur-md z-50 border-b border-gray-100">
          <nav className="container mx-auto px-6 py-4 flex justify-between items-center">
            <button onClick={onBack}>
              <img src="/x-logo.svg" alt="xharely logo" className="h-10 w-10" />
            </button>
            <button
              onClick={() => setSelectedPost(null)}
              className="flex items-center gap-2 text-gray-700 hover:text-black transition font-medium"
            >
              <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
              </svg>
              Blog
            </button>
          </nav>
        </header>
        <BlogDetail post={selectedPost} onBack={() => setSelectedPost(null)} />
      </>
    );
  }

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Fixed Navbar */}
      <header className="fixed top-0 w-full bg-white/90 backdrop-blur-md z-50 border-b border-gray-100">
        <nav className="container mx-auto px-6 py-4 flex justify-between items-center">
          <button onClick={onBack}>
            <img src="/x-logo.svg" alt="xharely logo" className="h-10 w-10" />
          </button>
          <div className="hidden md:flex items-center space-x-8">
            <button onClick={onBack} className="text-gray-700 hover:text-black transition font-medium">
              Home
            </button>
            <span className="text-black font-semibold border-b-2 border-black pb-0.5">Blog</span>
          </div>
          <button
            onClick={onBack}
            className="flex items-center gap-2 text-gray-700 hover:text-black transition font-medium md:hidden"
          >
            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
            </svg>
            Home
          </button>
        </nav>
      </header>

      {/* Hero */}
      <section className="pt-28 pb-16 bg-gradient-to-br from-white via-gray-50 to-yellow-50">
        <div className="container mx-auto px-6 max-w-4xl text-center">
          <span className="inline-block bg-black text-white text-xs font-bold px-4 py-1.5 rounded-full mb-6 tracking-widest uppercase">
            Blog
          </span>
          <h1 className="text-4xl sm:text-5xl md:text-6xl font-bold text-black leading-tight mb-6">
            Celoteh &amp; Perspektif
            <br />
            <span className="text-black">Xharely</span>
          </h1>
          <p className="text-lg sm:text-xl text-gray-600 max-w-2xl mx-auto">
            Artikel, tips, dan panduan seputar teknologi bisnis, transformasi digital, dan produk Xharely.
          </p>
        </div>
      </section>

      {/* Category Filter */}
      <div className="sticky top-16 z-40 bg-white/80 backdrop-blur-md border-b border-gray-100 shadow-sm">
        <div className="container mx-auto px-6">
          <div className="flex gap-2 py-3 overflow-x-auto no-scrollbar">
            {categories.map((cat) => (
              <button
                key={cat}
                onClick={() => setActiveCategory(cat)}
                className={`flex-shrink-0 px-5 py-2 rounded-full text-sm font-semibold transition-all duration-200 ${
                  activeCategory === cat
                    ? 'bg-black text-white shadow-md'
                    : 'bg-gray-100 text-gray-600 hover:bg-gray-200'
                }`}
              >
                {cat}
              </button>
            ))}
          </div>
        </div>
      </div>

      {/* Articles Grid */}
      <section className="py-12">
        <div className="container mx-auto px-6 max-w-6xl">
          {filtered.length === 0 ? (
            <div className="text-center py-24 text-gray-400">
              <svg className="w-16 h-16 mx-auto mb-4 opacity-40" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
              </svg>
              <p className="text-lg font-medium">Belum ada artikel di kategori ini.</p>
            </div>
          ) : (
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
              {filtered.map((post) => (
                <BlogCard key={post.id} post={post} onRead={setSelectedPost} />
              ))}
            </div>
          )}

          {/* Coming Soon */}
          <div className="mt-16 text-center">
            <div className="inline-flex flex-col items-center gap-3 bg-white border border-gray-200 rounded-2xl px-8 py-8 shadow-sm">
              <div className="w-12 h-12 bg-black rounded-full flex items-center justify-center">
                <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15.232 5.232l3.536 3.536m-2.036-5.036a2.5 2.5 0 113.536 3.536L6.5 21.036H3v-3.572L16.732 3.732z" />
                </svg>
              </div>
              <p className="text-gray-700 font-semibold">Lebih banyak artikel segera hadir</p>
              <p className="text-gray-500 text-sm max-w-xs">
                Tim Xharely sedang menyiapkan konten berkualitas. Pantau terus halaman ini.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-white pt-12 pb-8 border-t border-gray-100 mt-12">
        <div className="container mx-auto px-6 text-center">
          <button onClick={onBack}>
            <img src="/x-logo-text.svg" alt="xharely" className="h-8 w-auto mx-auto mb-4" />
          </button>
          <p className="text-gray-500 text-sm">
            &copy; {new Date().getFullYear()} PT Xharely Teknologi Indonesia. All rights reserved.
          </p>
        </div>
      </footer>
    </div>
  );
}

export default Blog;

